import { Box, Surface, Text } from '@/ui/primitives';
import { s } from '../../theme/tokens';
import type { ReactElement, ReactNode } from 'react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
  surface?: boolean;
};

export const EmptyState = ({
  icon,
  title,
  body,
  action,
  surface = true,
}: EmptyStateProps): ReactElement => {
  const content = (
    <Box sx={{ display: 'grid', gap: s('sm') }}>
      {icon ? <Box sx={{ fontSize: s('xl'), color: 'text.secondary' }}>{icon}</Box> : null}
      <Text role="sectionTitle">{title}</Text>
      {body ? <Text role="bodyMuted">{body}</Text> : null}
      {action ? <Box sx={{ marginTop: s('sm') }}>{action}</Box> : null}
    </Box>
  );

  if (!surface) {
    return <Box sx={{ textAlign: 'center' }}>{content}</Box>;
  }

  return (
    <Surface padding="xl" sx={{ textAlign: 'center' }}>
      {content}
    </Surface>
  );
};
